import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Layout',
      component: () => import('@/components/Layout.vue'),
      redirect: { name: 'SpatialDistribution' },
      children: [
        // level 0
        // {
        //   path: '/outdoor',
        //   name: 'Outdoor',
        //   // component: () => import('@/components/DataExports.vue'),
        //   props: {
        //     title: 'Outdoor'
        //   }
        // },

        // level 1 - Outdoor
        {
          path: ':env/spatial-distribution',
          name: 'SpatialDistribution',
          component: () => import('@/components/vizualizations/SpatialDistribution.vue'),
          props: {
            title: 'Spatial distribution'
          }
        },
        {
          path: '/data-availability',
          name: 'DataAvailability',
          // component: () => import('@/components/DataAvailability.vue'),
          props: {
            title: 'Data availability'
          }
        },
        {
          path: ':env/summary-statistics',
          name: 'SummaryStatistics',
          component: () => import('@/components/vizualizations/SummaryStatistics.vue'),
          props: {
            title: 'Summary statistics'
          }
        },
        {
          path: '/time-series',
          name: 'TimeSeries',
          // component: () => import('@/components/TimeSeries.vue'),
          props: {
            title: 'Time series'
          }
        },
        {
          path: '/data-exports',
          name: 'DataExports',
          // component: () => import('@/components/DataExports.vue'),
          props: {
            title: 'Data exports'
          }
        },
        {
          path: '/print',
          name: 'Print',
          component: () => import('@/components/PrintWrapper.vue'),
          props: {
            title: 'PrintWrapper'
          }
        },
        // level 2
        {
          path: ':env/data-availability/parameters',
          name: 'DataAvailabilityParameters',
          component: () => import('@/components/vizualizations/DataAvailabilityParameters.vue'),
          props: {
            title: 'Data availability - Parameters'
          }
        },
        {
          path: ':env/data-availability/time',
          name: 'DataAvailabilityTime',
          component: () => import('@/components/vizualizations/DataAvailabilityTime.vue'),
          props: {
            title: 'Data availability - Time'
          }
        },
        {
          path: ':env/data-availability/parameters-on-site-by-matrix',
          name: 'DataAvailabilityParametersOnSiteByMatrix',
          component: () => import('@/components/vizualizations/DataAvailabilityParametersOnSiteByMatrix.vue'),
          props: {
            title: 'Data availability - Parameters on site by matrices'
          }
        },
        {
          path: ':env/data-availability/parameters-on-site-in-time',
          name: 'DataAvailabilityParametersOnSiteInTime',
          component: () => import('@/components/vizualizations/DataAvailabilityParametersOnSiteInTime.vue'),
          props: {
            title: 'Data availability - Parameters on site in time'
          }
        },

        {
          path: ':env/time-series/trend-map',
          name: 'TimeSeriesTrendMap',
          component: () => import('@/components/vizualizations/TimeSeriesTrendMap.vue'),
          props: {
            title: 'Time series - Trend map'
          }
        },
        {
          path: ':env/time-series/trend-analysis',
          name: 'TimeSeriesTrendAnalysisDetail',
          component: () => import('@/components/vizualizations/TimeSeriesTrendAnalysis.vue'),
          props: {
            title: 'Trend analysis'
          }
        },

        {
          path: ':env/data-exports/all',
          name: 'DataExportsAllSummary',
          component: () => import('@/components/vizualizations/DataExportsAllSummary.vue'),
          props: {
            title: 'Data exports - All summary'
          }
        },
        {
          path: ':env/data-exports/sites',
          name: 'DataExportsSitesSummary',
          component: () => import('@/components/vizualizations/DataExportsSitesSummary.vue'),
          props: {
            title: 'Data exports - Sites summary',
            context: 'sites'
          }
        },
        {
          path: ':env/data-exports/analytical-methods',
          name: 'DataExportsAnalyticalMethodsSummary',
          component: () => import('@/components/vizualizations/DataExportsAnalyticalMethodsSummary.vue'),
          props: {
            title: 'Data exports - Analytical methods summary',
            context: 'analytical_methods'
          }
        },
        {
          path: ':env/data-exports/monitoring-networks',
          name: 'DataExportsMonitoringNetworksSummary',
          component: () => import('@/components/vizualizations/DataExportsMonitoringNetworksSummary.vue'),
          props: {
            title: 'Data exports - Monitoring networks summary',
            context: 'monitoring_networks'
          }
        },

        {
          path: ':env/regional-summaries/trends-summary',
          name: 'RegionalSummariesTrendsSummary',
          component: () => import('@/components/vizualizations/RegionalSummariesTrendsSummary.vue'),
          props: {
            title: 'Trends summary'
          }
        },
        {
          path: ':env/regional-summaries/data-availability-summary',
          name: 'RegionalSummariesDataAvailabilitySummary',
          component: () => import('@/components/vizualizations/RegionalSummariesDataAvailabilitySummary.vue'),
          props: {
            title: 'Data availability summary'
          }
        },
        {
          path: '*',
          name: 'PageNotFound',
          component: () => import('@/components/PageNotFound.vue'),
          props: {
            title: '404: Page not found...'
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next({name: 'PageNotFound'})
  } else {
    next()
  }

  // this.showProgress = true
})

// router.afterEach((to, from) => {
//   this.showProgress = false
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js